import { useCallback } from 'react';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { useUserContext } from '@context/UserContext';
import { useGetPreviousPageUrl } from '@services/routingService';

import { trackCartPageViewEvent, trackViewCartEvent, trackDeloitteCartPageView } from '../../events';
import { IEcommerceCheckout } from '../../model';

export const useTrackViewCartPageEvent = () => {
  const {
    applicationSettings: {
      features: { googleRetailApiUserEvents },
    },
  } = useApplicationRuntimeContext();

  const { state } = useUserContext();
  const previousPageUrl = useGetPreviousPageUrl();

  return useCallback(
    (ecommerceCheckout: IEcommerceCheckout) => {
      if (googleRetailApiUserEvents) {
        trackDeloitteCartPageView(ecommerceCheckout, state);
      }

      trackCartPageViewEvent(previousPageUrl);
      trackViewCartEvent(ecommerceCheckout);
    },
    [googleRetailApiUserEvents, state, previousPageUrl],
  );
};
